import type TemporalUnit from "./TemporalUnit";
import dateTime from "./dateTime";

type Options = {
  timeZone?: string;
  locale?: string;
};

/**
 * @deprecated Use `dateTime(date, { timeZone }).startOf(unit)`.
 **/
export default function startOf(
  date: Date,
  unit: TemporalUnit,
  options: Options = {},
) {
  return dateTime(date, options).startOf(unit).toJSDate();
}
